import React from 'react'

function Meta({ label, value }) {
  return (
    <div>
      <div className="field-label">{label}</div>
      <div className="field-val">{value}</div>
    </div>
  )
}

export default Meta
